import content from "./contactContent.json";
import './contact.css'

const ContactUs = () => {
    return (
<section className="contact-wrapper">
  <div className="contact-container">
    <h1 className="contact-title">{content.title}</h1>
    <p className="contact-intro">{content.intro}</p>

    <div className="contact-sections">
      {content.sections.map((section, idx) => (
        <div key={idx} className="contact-section">
          <h2 className="contact-heading">{section.heading}</h2>
          <p className="contact-text">{section.text}</p>
          {section.email && (
            <p className="contact-text">
              <strong>Email:</strong>{" "}
              <a href={`mailto:${section.email}`} className="contact-link">
                {section.email}
              </a>
            </p>
          )}
          {section.subject && (
            <p className="contact-text">
              <strong>Subject:</strong> {section.subject}
            </p>
          )}
          {section.list && (
            <ul className="contact-list">
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      ))}

      <div className="contact-address">
        <h2 className="contact-heading">📍 Business Address</h2>
        <p className="contact-text">
          <strong>{content.address.company}</strong>
          <br />
          {content.address.line1}
          <br />
          {content.address.line2}
        </p>
      </div>

      <p className="contact-footer">{content.footer}</p>
    </div>
  </div>
</section>


    );
  }
  
    export default ContactUs